/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function formRequest(value) {
    const rootUrl = Shopify?.routes?.root || Shopify?.routes?.rootUrl;
    return fetch(rootUrl + 'products/' + value + '?view=boost-sd-integration').then(response => response.text()).catch((error) => console.error(error))
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductItem - call get Products Data',
            apply() {
                return {
                     afterRender(element) {
                        const productData = element.getParams().props.product;
                        if (!productData) {
                            return
                        }

                        let productId = productData.id;
                        if (productData?.split_product) {
                            productId = productData.variant_id;
                        }

                        const productBoostElm = document.querySelector('[data-product-id="' + productId + '"]');
                        if (!productBoostElm) {
                            return
                        }

                        const rootUrl = Shopify?.routes?.root || Shopify?.routes?.rootUrl;
                        fetch(rootUrl + 'products/' + productData.handle + '/?view=boost-sd-integration')
                        .then(response => response.text())
                        .then(response => {
                            if (productBoostElm && !productBoostElm.querySelector('.boost-sd__custom-swatches')) {
                                const res = JSON.parse(response);

                                productBoostElm.insertAdjacentHTML('beforeend', res.swatches.trim());
                            }

                        })
                        .catch((error) => console.error(error))
                      
                    },
                };
            },
        });
    }
]);